export enum EventFilterIs {
    Attending = "attending",
    Attended = "attended",
    Interested = "interested",
    InviteRequested = "requested",
    MyEvents = "my-events",
    MyEventsUpcoming = "my-events-upcoming",
    MyEventsPast = "my-events-past",
}